import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  CreateTariffCoefficientPayload,
  CreateTariffPayload,
  NannyTariffsApiResponse,
  NannyTariffsConfig,
  TariffCoefficientEntry,
  TariffCoefficientsConfig,
  TariffEntry,
  TariffServiceOption,
  UpdateTariffCoefficientPayload,
  UpdateTariffPayload,
} from 'shared-components';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class CompanyNannyTariffsService implements NannyTariffsConfig, TariffCoefficientsConfig {
  private readonly tariffsUrl = `${environment.apiUrl}/company/service-tariffs`;

  constructor(private readonly http: HttpClient) {}

  listTariffs(): Observable<NannyTariffsApiResponse<TariffEntry[]>> {
    return this.http.get<NannyTariffsApiResponse<TariffEntry[]>>(this.tariffsUrl);
  }

  listActiveServices(): Observable<NannyTariffsApiResponse<TariffServiceOption[]>> {
    return this.http.get<NannyTariffsApiResponse<TariffServiceOption[]>>(`${environment.apiUrl}/services-catalog/active`);
  }

  createTariff(dto: CreateTariffPayload): Observable<NannyTariffsApiResponse<TariffEntry>> {
    return this.http.post<NannyTariffsApiResponse<TariffEntry>>(this.tariffsUrl, dto);
  }

  updateTariff(id: number, dto: UpdateTariffPayload): Observable<NannyTariffsApiResponse<TariffEntry>> {
    return this.http.patch<NannyTariffsApiResponse<TariffEntry>>(`${this.tariffsUrl}/${id}`, dto);
  }

  setTariffActive(id: number, active: boolean): Observable<NannyTariffsApiResponse<TariffEntry>> {
    return this.http.patch<NannyTariffsApiResponse<TariffEntry>>(`${this.tariffsUrl}/${id}/active`, { active });
  }

  deleteTariff(id: number): Observable<NannyTariffsApiResponse<null>> {
    return this.http.delete<NannyTariffsApiResponse<null>>(`${this.tariffsUrl}/${id}`);
  }

  getCoefficients(serviceCode: string): Observable<NannyTariffsApiResponse<TariffCoefficientEntry[]>> {
    return this.http.get<NannyTariffsApiResponse<TariffCoefficientEntry[]>>(`${this.tariffsUrl}/${serviceCode}/coefficients`);
  }

  createCoefficient(serviceCode: string, dto: CreateTariffCoefficientPayload): Observable<NannyTariffsApiResponse<TariffCoefficientEntry>> {
    return this.http.post<NannyTariffsApiResponse<TariffCoefficientEntry>>(`${this.tariffsUrl}/${serviceCode}/coefficients`, dto);
  }

  updateCoefficient(serviceCode: string, id: number, dto: UpdateTariffCoefficientPayload): Observable<NannyTariffsApiResponse<TariffCoefficientEntry>> {
    return this.http.patch<NannyTariffsApiResponse<TariffCoefficientEntry>>(`${this.tariffsUrl}/${serviceCode}/coefficients/${id}`, dto);
  }

  deleteCoefficient(serviceCode: string, id: number): Observable<NannyTariffsApiResponse<null>> {
    return this.http.delete<NannyTariffsApiResponse<null>>(`${this.tariffsUrl}/${serviceCode}/coefficients/${id}`);
  }
}
